import Vue from 'vue'
import loading from 'vuejs-loading-screen'

// Vue.use(loading)

Vue.use(loading, {
    bg: '#9a9a9a',
})